import { Template } from "app/main/pages/edit-template/edit-template.dto";
import { HttpActionState } from "app/main/pages/users/userslisting/store/users-listing.reducers";
import { RecipientRole } from 'app/main/pages/edit-template/edit-template.dto';

export interface OnlineContractState {
    template: Template,
    fetchOnlineContractRequestState:HttpActionState,
    signOnlineContractRequestState:HttpActionState,
    sendOnlineContractInvitationRequestState:HttpActionState,
    visitedRoles: RecipientRole[];
}

export const InitialState: OnlineContractState = {
    template: null,
    fetchOnlineContractRequestState: HttpActionState.Init,
    signOnlineContractRequestState: HttpActionState.Init,
    sendOnlineContractInvitationRequestState: HttpActionState.Init,
    visitedRoles: [],
}

export const featureKey = 'OnlineContract';